import { LoadingAction } from 'src/app/shared/models/loading-action.enum';

export const CUSTOM_EVENT_QUERY_PARAM_NAME = 'custom-button-loader-name';

export function getCustomEvent(
  action: LoadingAction,
  namespace: string,
  id: string,
): { [key: string]: string } {
  return { [CUSTOM_EVENT_QUERY_PARAM_NAME]: `${action}_${namespace}_${id}` };
}
